import React from 'react';
import './VideoGallery.css';

const videos = [
  {
    title: "How We Safely Pack and Move Fragile Items",
    iframe: `<iframe width="560" height="315" src="https://www.youtube.com/embed/TdJoBKyncUQ?si=70v8NA3xk0k_p6Wk" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`,
    thumbnail: "thumbnail1.jpg",
  },
  {
    title: "Behind the Scenes of a Seamless Office Relocation",
    iframe: `<iframe width="560" height="315" src="https://www.youtube.com/embed/utYOw7xOmPg?si=AkrIWXW5qzNzTC4y" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`,
    thumbnail: "thumbnail2.jpg",
  },
  {
    title: "Customer Testimonials",
    iframe: `<iframe width="560" height="315" src="https://www.youtube.com/embed/tyIMFC63qBw?si=iuVlaf_yl07sM3rq" title="YouTube video player" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" referrerpolicy="strict-origin-when-cross-origin" allowfullscreen></iframe>`,
    thumbnail: "thumbnail3.jpg",
  },
];

export default function VideoGallery() {
  return (
    <section className="video-section">
      <div className="video-header">
        <h2>Watch Us in Action</h2>
        <p>Discover how we simplify compliance and consulting with our expert solutions.</p>
      </div>
      <div className="video-grid">
        {videos.map((video, index) => (
          <div key={index} className="video-item">
            <div className="video-thumbnail">
              
              <div
                className="video-embed"
                dangerouslySetInnerHTML={{ __html: video.iframe }}
              />
            </div>
            <div className="video-title">{video.title}</div>
          </div>
        ))}
      </div>
    </section>
  );
}
